(() => {
  if (customElements.get('free-shipping-progress')) return;

  class FreeShippingProgress extends HTMLElement {
    connectedCallback() {
      this.update({ total_price: Number(this.dataset.total), currency: this.dataset.currency });
    }

    update(cart) {
      const previewAllMarkets = this.dataset.previewAllMarkets === 'true';
      const storefrontCurrency = window.Shopify?.currency;
      const rate = cart.currency === 'USD' ? 1
        : previewAllMarkets && this.dataset.baseCurrency === 'USD' && storefrontCurrency?.active === cart.currency
          ? Number(storefrontCurrency.rate) : NaN;
      const threshold = Math.round(Number(this.dataset.threshold) * rate);
      const total = cart.total_price;
      this.hidden = (!previewAllMarkets && (this.dataset.country !== 'US' || cart.currency !== 'USD'))
        || !Number.isFinite(total) || total < 0 || !Number.isFinite(threshold) || threshold <= 0;
      if (this.hidden) return;
      this.dataset.total = total;
      const remaining = Math.max(0, threshold - total);
      this.dataset.complete = String(remaining === 0);
      const formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: cart.currency });
      const amount = formatter.format(remaining / 100);
      const message = remaining ? `${amount} to free US shipping` : 'Free US shipping';
      this.querySelector('[data-shipping-message]').textContent = message;
      this.querySelector('.shipping-progress__goal').textContent = `${formatter.format(threshold / 100).replace(/\.00$/, '')} ${cart.currency}`;
      const track = this.querySelector('[role="progressbar"]');
      track.setAttribute('aria-valuemax', threshold);
      track.setAttribute('aria-valuenow', Math.min(total, threshold));
      track.setAttribute('aria-valuetext', message);
      this.querySelector('.shipping-progress__fill').style.width = `${Math.min(100, total / threshold * 100)}%`;
    }
  }

  customElements.define('free-shipping-progress', FreeShippingProgress);

  let revision = 0;
  subscribe(PUB_SUB_EVENTS.cartUpdate, async ({ cartData } = {}) => {
    const current = ++revision;
    if (!document.querySelector('free-shipping-progress')) return;
    let cart = cartData;
    try {
      if (!Number.isFinite(cart?.total_price) || !cart?.currency) {
        // Add responses describe the added item, not the cart total. Prefer the
        // cart section Shopify rendered for that same successful mutation.
        const markup = Object.values(cart?.sections || {}).find(html => html?.includes('<free-shipping-progress'));
        const progress = markup && new DOMParser().parseFromString(markup, 'text/html').querySelector('free-shipping-progress');
        if (progress) {
          cart = { total_price: Number(progress.dataset.total), currency: progress.dataset.currency };
        } else {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, { cache: 'no-store' });
          if (!response.ok) throw new Error('Cart unavailable');
          cart = await response.json();
        }
      }
      if (current !== revision) return;
      document.querySelectorAll('free-shipping-progress').forEach(progress => progress.update(cart));
    } catch (_) {
      if (current === revision) document.querySelectorAll('free-shipping-progress').forEach(progress => { progress.hidden = true; });
    }
  });
})();
